const ERROR_MESSAGES = {
  "auth/invalid-email": "Please enter a valid email address.",
  "auth/user-disabled": "This account is disabled. Contact support if this is unexpected.",
  "auth/user-not-found": "No account found with that email.",
  "auth/wrong-password": "Incorrect password. Try again.",
  "auth/invalid-credential": "Email or password is incorrect.",
  "auth/email-already-in-use": "That email is already in use. Sign in instead.",
  "auth/weak-password": "Password must be at least 6 characters.",
  "auth/too-many-requests": "Too many attempts. Please wait a minute and try again.",
  "auth/popup-closed-by-user": "Sign-in popup was closed before completion.",
  "auth/network-request-failed": "Network issue detected. Check your connection and try again.",
  "permission-denied": "You do not have permission to do that action.",
  "failed-precondition": "That action can’t be completed in the current state.",
  "not-found": "We could not find what you requested.",
  "already-exists": "This already exists.",
  "resource-exhausted": "Limit reached for this plan. Upgrade to continue."
};

const includesAny = (value, patterns) => patterns.some((pattern) => value.includes(pattern));

export const mapFirebaseError = (error, fallback = "Something went wrong. Please try again.") => {
  const code = String(error?.code || "").replace(/^functions\//, "");
  const direct = ERROR_MESSAGES[code];
  if (direct) return direct;

  const message = String(error?.message || "").toLowerCase();

  if (includesAny(message, ["invite", "code", "join"]) && includesAny(message, ["invalid", "expired", "not found"])) {
    return "Invite code is invalid or expired. Ask for a fresh code.";
  }

  if (includesAny(message, ["already exists", "duplicate"])) {
    return "That already exists.";
  }

  if (includesAny(message, ["network", "offline", "timed out"])) {
    return "Connection issue detected. Please try again.";
  }

  if (includesAny(message, ["permission", "not authorized"])) {
    return "You do not have permission for that action.";
  }

  return fallback;
};
